/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Refresh_Success_ToastInputs */



/**
* | output |
* | --- |
* | "Search filters refreshed." |
*
* @param {Explorer_Search_Refresh_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_refresh_success_toast = /** @type {((inputs?: Explorer_Search_Refresh_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Refresh_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Search filters refreshed.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Search filters refreshed.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Search filters refreshed.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Search filters refreshed.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Search filters refreshed.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Search filters refreshed.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Search filters refreshed.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Search filters refreshed.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Search filters refreshed.")
	return /** @type {LocalizedString} */ ("Search filters refreshed.")
});